(() => {
  function init(root = document) {
    root.querySelectorAll('.lh-article').forEach(article => {
      const toc = article.querySelector('.lh-guide-toc');
      if (!toc || toc.dataset.ready) return;
      const headings = [...article.querySelectorAll('.article__content h2')].filter(h => h.textContent.trim());
      if (headings.length < 3) return;
      headings.forEach((h, i) => {
        if (!h.id) { let id = `guide-section-${i + 1}`; while (document.getElementById(id)) id += '-section'; h.id = id; }
        const a = document.createElement('a'); a.href = '#' + encodeURIComponent(h.id); a.textContent = h.textContent; toc.querySelector('nav').append(a);
      });
      toc.hidden = false; toc.open = matchMedia('(min-width:981px)').matches; toc.dataset.ready = 'true';
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
